import { LogService } from 'library/ts/utilities/logger/LogService';
import { APISkinMobileWeb } from 'tag/ts/tag/api/APISkinMobileWeb';
export class API {
    #tag;
    #mobileWebSkinAPI;
    #logger;
    constructor(argument) {
        this.#tag = argument?.tag;
        this.#logger = LogService.create({ prefixes: ['SmartTag:', 'Tag:', this.#tag?.uuid, this?.name] });
        this.#mobileWebSkinAPI = (window.SmartTag.capabilities.isDesktop === false
            ? new APISkinMobileWeb({ tag: this.#tag })
            : undefined);
    }
    get name() {
        return 'API';
    }
    get utils() {
        return window.SmartTag.utilities;
    }
    get TAG() {
        return this.#tag?.controller?.tagAPI?.IN;
    }
    get VIDEO() {
        return this.#tag?.controller?.videoAPI?.IN;
    }
    get CAST() {
        return this.#tag?.view?.skin?.API?.CAST_IN;
    }
    get SKIN() {
        switch (window.SmartTag.capabilities.isDesktop) {
            case true:
                return this.#tag?.view?.skin?.API?.SKIN_IN;
            case false:
                return this.#mobileWebSkinAPI?.IN;
        }
        return undefined;
    }
    get PLAYER() {
        return this.#tag?.controller?.playerManager?.player;
    }
}
